import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { HelperFunctions, IPhoto } from '@curbnturf/entities';
import { SpinnerComponent } from '@curbnturf/ui/src/lib/spinner/spinner.component';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  standalone: true,
  selector: 'curbnturf-activity-location-photo',
  templateUrl: './activity-location-photo.component.html',
  styleUrls: ['./activity-location-photo.component.scss'],
  imports: [IonicModule, NgIf, SpinnerComponent],
})
export class ActivityLocationPhotoComponent {
  @Input() currentPhoto?: IPhoto;
  loaded: boolean = false;

  getLargePhotoUrl = HelperFunctions.getPhotoUrl;

  constructor(public modalController: ModalController) {}

  closeModal() {
    this.modalController.dismiss();
  }
}
